import { Service, ServiceField } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * VariantFieldsProcessor формирует список полей для всех услуг внутри всех вариантов
 */
export class VariantFieldsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const servicesByDir: { directoryID: string; services: Service[] }[] = [];
    const fields: { [T in string]: ServiceField[] } = {};

    if (additionalServiceState.LastServiceInPath.is_variants) {
      additionalServiceState.Variants.map((variant) => {
        fields[variant.id] = [...variant.fields];
      });
    }

    Object.entries(additionalServiceState.VariantServices).forEach(([dirId, services]) => {
      servicesByDir.push({ directoryID: dirId, services });
    });

    servicesByDir.map((r) => {
      fields[r.directoryID] = [
        ...(fields[r.directoryID] ?? []),
        ...r.services
          .map((s) => [...s.fields, ...s.additionServices.map((s) => s.fields).flat(1)])
          .flat(1),
      ];
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantFields: fields,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
